export const ToastKeys = {
    httpError: 'HTTP_ERROR',
};
